import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const CheckCheck: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M18 6 7 17l-5-5' }],
    ['path', { d: 'm22 10-7.5 7.5L13 16' }],
  ],
];

export default CheckCheck;
